import { SvgIcon } from '@mui/material';

export default function MinusIcon(props) {
  return (
    <SvgIcon
      width='24'
      height='24'
      viewBox='0 0 24 24'
      style={{ fill: 'currentColor', stroke: 'none' }}
      {...props}
    >
      <path d='M5.5 12.5V11.5H18.5V12.5H5.5Z' fill='currentColor' />
    </SvgIcon>
  );
}

